import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
// Librairie
import {useHistory} from "react-router-dom";
// Layout
import Wrapper from "../Layout/Wrapper/Wrapper";
import MessagerieWrapper from "../Layout/MessagerieWrapper/MessagerieWrapper";
import ContainerMessagerie from "../Layout/ContainerMessage/ContainerMessagerie";
// Composant
import Modal from "../../../containers/Chat/ChatCase/Modal";
import AcceptPapModal from "./Modal/AcceptPapModal";
import RejectPapModal from "./Modal/RejectPapModal";
import RejectDevisModal from "./Modal/RejectDevisModal";
import AcceptDevisModal from "./Modal/AcceptDevisModal";
import Messages from "./Messages/Messages";
import Form from "./Form/Form";
import DocumentList from "./DocumentList/DocumentList";
import DevisList from "./DevisList/DevisList";
import DocumentSideBarTitle from "../shared/DocumentSideBarTitle/DocumentSideBarTitle";
import ColoneChatInfos from "../shared/ColoneChatInfos/ColoneChatInfos";
import ChatTitle from "../shared/ChatTitle/ChatTitle";
import Alerte from "../shared/Alerte/Alerte";
// Assets
import checkIcon from "../../../assets/icons/check.svg";
import errorIcon from "../../../assets/icons/error.svg";
import docs from "../../../assets/icons/docs.svg";
import docs2 from "../../../assets/icons/docs2.svg";
import mess from "../../Home/assets/navItems/careManager.svg";
import mess2 from "../../Home/assets/navItems/careManager2.svg";
import "./styles.scss";
// Hook
import useWindowDimensions from "../../../hook/useWindowDimension";
import addDocument from "../../../assets/icons/addDocument.svg";
import Nav from "../../../containers/Nav/Nav";

// Seul le composant ChatCase est connecté au store. Les sous composant qui le compose
// reçoivent les props de parent à enfant. On pourrait connecter les sous composants au store via container
// mais il n'y a qu'un seul niveau de passage de props dans l'arborescence donc ce n'est pas non plus ultra ilisaible
const ChatCase = ({
																		cas,
																		contact,
																		documents,
																		messages,
																		setMessageValue,
																		messageValue,
																		getMessages,
																		setIdCase,
																		loadingCases,
																		postMessage,
																		getDocuments,
																		setShowModalRerender,
																		setShowModalNoRerender,
																		setShowAcceptPapModal,
																		setShowAcceptDevisModal,
																		setShowRejectPapModal,
																		setShowRejectDevisModal,
																		showModal,
																		showModalNoRerender,
																		showAcceptPapModal,
																		showAcceptDevisModal,
																		showRejectPapModal,
																		showRejectDevisModal,
																		successUploadMess,
																		errorUploadMess,
																		acceptPap,
																		rejectPap,
																		showPap,
																		setShowPap,
																		getCases,
																		changeStatus,
																		updateUnreadMessages,
																		updateDevisState,
																		showSideBar,
																		toggleSideBar
																		}) => {

// Permet de fermer la sidebar document si la
// fenêtre est redimensionner au delà de 1024px
const {width} = useWindowDimensions();
const [showDocuments, setShowDocuments] = useState(false);
const [openFreeQuestionChatBot, setOpenFreeQuestionChatBot] = useState(false);
const [displayQuestions, setDisplayQuestions] = useState(true);
useEffect(() => {
if (width > 599) {
toggleSideBar(false);
}
}, [width]);

useEffect(() => {
// Si un cas existe
if (cas) {
//On sauvegarde l'id du cas dans le state
//Pour pouvoir l'utiliser dans les middlewares
setIdCase(cas.id);
}
}, []);

useEffect(() => {
window.scrollTo(0, 0);
}, []);

useEffect(() => {
if (messages.length > 0 && cas) {
updateUnreadMessages(cas.id);
}
});
useEffect(() => {
// Cas avec un status égal à 100 => refusé
// Cas avec un status égal à 4 => en attente d'acceptation
// Cas avec un status strictement supérieur à 4 => accepté
if (cas) {
if (cas.state == 100) {
setShowPap(false);
} else if (cas.state < 4) {
setShowPap(false);
} else {
setShowPap(true);
}
}
// return null;
}, []);

useEffect(() => {
// odingCases passe à true lorsque la requête pour récupérer
// les cas est terminé
if (!loadingCases) {

const setIdBeforeGetMessage = async () => {
if (cas) {
await setIdCase(cas.id);
}
};
// On attends que soit assigné une valeur à idCase
// avant de lancer les requêtes,
// sans quoi, elle ne pourrait pas s'exécuter
setIdBeforeGetMessage().then(() => {
getDocuments();
getMessages();
});
// On lance la requete getMessage toutes les 15 secondes, ce qui permet de vérifier s'il y a un nouveau message
// Dans la requête getMessage, on compare le tableau de message actuel dans le state
// Si le tableau provenant de la requête est différent du tableau actuel présent dans le state, on le met à jour,
// ce qui aura pour conséquence de mettre à jour le composant et d'afficher le dernier message envoyé.
// cf. "./middlewares/messages.js", action GET_MESSAGES
const refreshMessage = setInterval(() => {
setIdBeforeGetMessage().then(getMessages());
}, 15000);

// Lorsque le composant est démonté, on arrête de requêté les messages
return () => {
clearInterval(refreshMessage);
};
}
}, [loadingCases]);

const history = useHistory();

const handleBackButton = () => {
history.push("/");
};
const toggleModal = () => {
// Affiche la modal d'upload des fichiers
setShowModalNoRerender(!showModalNoRerender);
};
return (
<>
<Wrapper>
{cas && messages !== undefined &&
<>
<Nav
setDisplayQuestions={setDisplayQuestions}
/>

<MessagerieWrapper
showSideBar={showSideBar}
>
<ChatTitle
showDocumentButton={true}
caremanagerFirstname={cas.firstname}
caremanagerName={cas.name}
aidant={contact ? `${contact.prenom}  ${contact.nom}` : ""}
onclick={handleBackButton}
/>
{(showDocuments && (width < 599))
?
<>
<DocumentList
documents={documents}
cas={cas} setShowModalNoRerender={setShowModalNoRerender}
showModalNoRerender={showModalNoRerender}
/>
<DevisList documents={documents}/>
</>
: <> <ContainerMessagerie>
<Messages
messages={messages}
cas={cas}
acceptPap={acceptPap}
rejectPap={rejectPap}
setShowAcceptPapModal={setShowAcceptPapModal}
setShowAcceptDevisModal={setShowAcceptDevisModal}
setShowRejectPapModal={setShowRejectPapModal}
setShowRejectDevisModal={setShowRejectDevisModal}
showAcceptPapModal={showAcceptPapModal}
showAcceptDevisModal={showAcceptDevisModal}
showRejectPapModal={showRejectPapModal}
showRejectDevisModal={showRejectDevisModal}
setShowPap={setShowPap}
showPap={showPap}
documents={documents}
/>
</ContainerMessagerie>
<Form
setMessageValue={setMessageValue}
messageValue={messageValue}
postMessage={postMessage}
cas={cas}
/>
</>
}
</MessagerieWrapper>

{/*Colone d'informations situé sur la droite au dessus de 1024px*/}
{/*La coloneChatInfo à des commposants enfants*/}
<ColoneChatInfos
enableDocument={documents ? true : false}
backgroundImgId={cas.idCareManager}
firstname={cas.firstname}
lastname={cas.name}
tel={cas.tel}
cas={cas}
openFreeQuestionChatBot={openFreeQuestionChatBot}
>
{width > 599
? <>
<DocumentList
documents={documents}
cas={cas}
setShowModalNoRerender={setShowModalNoRerender}
showModalNoRerender={showModalNoRerender}
/>
<DevisList documents={documents}/>
</>
: <div className={"nav-doc-mess"}>
<div
className={"documents-devis-mobile"}
style={{backgroundColor: showDocuments ? "#FF6744" : ""}}
>
<img onClick={() => setShowDocuments(true)}
					src={showDocuments ? docs2 : docs}
/>
</div>
<div className={"messagerie-button-mobile"}
					style={{backgroundColor: showDocuments ? "" : "#FF6744"}}
>
<img onClick={() => setShowDocuments(false)}
					src={showDocuments ? mess : mess2}
/>
</div>
</div>
}
</ColoneChatInfos>

{showSideBar &&
// Sidebar (pas vraiement une sidebar mais plutôt un menu ouvrable) présente en responsive
// On retouve les mêmes éléments que dans ColoneChatInfos, c'est sjute l'agencement  qui est différent
<aside className={showSideBar ? "activeDocumentSideBar" : "disabledDocumentSideBar"}>
<DocumentSideBarTitle
caremanagerName={cas.firstname}
aidant={contact ? `${contact.prenom}  ${contact.nom}` : ""}
onclick={() => toggleSideBar(!showSideBar)}
setShowModalNoRerender={setShowModalNoRerender}
showModalNoRerender={showModalNoRerender}
/>
<div className={"documents-devis-mobile"}>
<div className={"toggle-documents-devis"}>
<button onClick={() => setShowDocuments(!showDocuments)}
								className={`toggleDocument ${showDocuments ? "activeToggle" : "disabledToggle"}`}>Documents
</button>
</div>
<button className="document" id={"addDocument"} onClick={toggleModal}>
<img className="image-document" src={addDocument} alt=""/>
</button>
</div>
{showDocuments &&
<>
<DocumentList
documents={documents}
cas={cas} setShowModalNoRerender={setShowModalNoRerender}
showModalNoRerender={showModalNoRerender}
/>
<DevisList documents={documents}/>
</>
}
</aside>
}
</>
}
{successUploadMess &&
<Alerte src={checkIcon} text={successUploadMess} activeClass={"success"}/>
}
{errorUploadMess &&
<Alerte src={errorIcon} text={errorUploadMess} activeClass={"error"}/>
}
</Wrapper>
{showModalNoRerender &&
// Modal d'upload des docuements pour l'utilisateur
// Passage de props ChatCase -> Modal -> Uploadfile peut être pas nécéssaire, à revoir dans le container UplopadFile si on peut transmettre ces props
<Modal
setShowModalRerender={setShowModalRerender}
setShowModalNoRerender={setShowModalNoRerender}
showModal={showModal}
showModalNoRerender={showModalNoRerender}
idCase={cas.id}
/>
}
{showAcceptPapModal &&
// Modla d'acceptation du plan d'aide personnalisé
<AcceptPapModal
setShowAcceptPapModal={setShowAcceptPapModal}
showAcceptPapModal={showAcceptPapModal}
idCase={cas.id}
acceptPap={acceptPap}
getCases={getCases}
changeStatus={changeStatus}
/>
}
{showRejectPapModal &&
// Modla de refus du plan d'aide personnalisé
<RejectPapModal
setShowRejectPapModal={setShowRejectPapModal}
showRejectPapModal={showRejectPapModal}
idCase={cas.id}
setMessageValue={setMessageValue}
messageValue={messageValue}
rejectPap={rejectPap}
postMessage={postMessage}
cas={cas}
setShowPap={setShowPap}
showPap={showPap}
changeStatus={changeStatus}
/>
}
{showAcceptDevisModal &&
// Modla d'acceptation des devis
<AcceptDevisModal
setShowAcceptDevisModal={setShowAcceptDevisModal}
showAcceptDevisModal={showAcceptDevisModal}
updateDevisState={updateDevisState}
/>
}
{showRejectDevisModal &&
// Modla de refus des devis
<RejectDevisModal
setShowRejectDevisModal={setShowRejectDevisModal}
showRejectDevisModal={showRejectDevisModal}
setMessageValue={setMessageValue}
postMessage={postMessage}
cas={cas}
updateDevisState={updateDevisState}
/>
}
</>
);
};

ChatCase.propTypes = {
cas: PropTypes.object,
contact: PropTypes.object,
documents: PropTypes.array,
messages: PropTypes.array,
messageValue: PropTypes.object,
setMessageValue: PropTypes.func,
getDocuments: PropTypes.func,
addMessage: PropTypes.func,
setIdCase: PropTypes.func,
getMessages: PropTypes.func,
postMessage: PropTypes.func,
setShowModalRerender: PropTypes.func,
setShowModalNoRerender: PropTypes.func,
setShowAcceptPapModal: PropTypes.func,
setShowAcceptDevisModal: PropTypes.func,
setShowRejectPapModal: PropTypes.func,
setShowRejectDevisModal: PropTypes.func,
loadingCases: PropTypes.bool,
showModal: PropTypes.bool,
showModalNoRerender: PropTypes.bool,
showAcceptPapModal: PropTypes.bool,
showAcceptDevisModal: PropTypes.bool,
showRejectPapModal: PropTypes.bool,
showRejectDevisModal: PropTypes.bool,
showSideBar: PropTypes.bool,
successUploadMess: PropTypes.string,
errorUploadMess: PropTypes.string,
acceptPap: PropTypes.func,
rejectPap: PropTypes.func,
setShowPap: PropTypes.func,
getCases: PropTypes.func,
showPap: PropTypes.bool,
changeStatus: PropTypes.func,
updateUnreadMessages: PropTypes.func,
updateDevisState: PropTypes.func,
toggleSideBar: PropTypes.func,
};

export default ChatCase;
